<template>
    <div class="row">
        <div class="col-4 text-right mt-2">{{$t('userprofile.data.email')}}:</div>
        <div class="col-8 mt-2">{{ this.$store.state.user.user.email }}</div>

        <div class="col-4 text-right mt-2">{{$t('userprofile.data.contact')}}:</div>
        <div class="col-8 mt-2">{{ this.$store.state.user.user.phone_no }}</div>

        <div class="col-4 text-right mt-2">{{$t('userprofile.data.location')}}:</div>
        <div class="col-8 mt-2">{{ this.$store.state.user.user.location }}</div>
    </div>
</template>

<script>
import Vue from 'vue';
export default {
    name: 'profile_about',
}
</script>


// WEBPACK FOOTER //
// src/components/pages/users/profile/profile_about.vue